import React from 'react'
import { Circle } from '../geometries/Circle'
import { Cylinder } from '../geometries/Cylinder'
import { Ring } from '../geometries/Ring'

export const Pot = ({ position, rotation, scale = 1 }) => {
	return (
		<group castShadow position={position} scale={[scale, scale, scale]} rotation={rotation}>
			<Cylinder size={[1.3, 1, 1.8, 50]} position={[0, 0.9, 0]} color='gray' />
			<Ring size={[1.5, 1.5, 0.3, 50]} width={0.3} position={[0, 1.9, 0]} color='gray' />
			<Circle rotation={[-Math.PI / 2, 0, 0]} position={[0, 2, 0]} />
		</group>
	)
}
